import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Clickable from "../components/clickable.";
import images from "../constants/images";
import Page from "../components/page";
import api from "../functions/api";
import toast from "../functions/toast";

const AddMachine = () => {
    const [machineName, setMachineName] = useState("");
    const [heads, setHeads] = useState("");
    const [area, setArea] = useState("");

    const addMachine = async () => {
        try {
            await api.post("/add-machine", {
                name: machineName,
                serialNum: 1,
                head: heads,
                area,
            });
            toast.success("Machine added");
            navigate(-1);
        } catch (err) {
            console.log("🚀 ~ getMachine ~ err:", err);
        }
    };

    const navigate = useNavigate();

    const handleCancel = () => {
        navigate(-1);
    };

    return (
        <Page title="Add Machine">
            <div className="add-machine">
                <div className="style-0">
                    <div className="style-5">
                        <div className="style-6">Machine Name :</div>

                        <div className="style-8">
                            <input
                                className="style-11"
                                placeholder="Machine Name"
                                value={machineName}
                                onChange={(e) =>
                                    setMachineName(e.currentTarget.value)
                                }
                            />
                        </div>
                    </div>

                    {/* <div className="style-5">
                        <div className="style-6">Status</div>

                        <select classNameName="style-20">
                            <option>Active</option>
                            <option>Deactivate</option>
                        </select>
                    </div> */}

                    <div className="style-5">
                        <div className="style-6">Heads :</div>

                        <div className="style-8">
                            <input
                                className="style-11"
                                type="number"
                                value={heads}
                                inputMode="numeric"
                                onChange={(e) =>
                                    setHeads(e.currentTarget.value)
                                }
                            />
                        </div>
                    </div>

                    <div className="style-5">
                        <div className="style-6">Area :</div>

                        <div className="style-8">
                            <input
                                className="style-11"
                                type="number"
                                value={area}
                                onChange={(e) => setArea(e.currentTarget.value)}
                                inputMode="numeric"
                            />
                        </div>
                    </div>
                </div>

                <div className="save-button">
                    <Clickable className="cancel-b" onClick={handleCancel}>
                        <img src={images.close} className="cancel-icon" />
                        Cancel
                    </Clickable>
                    <Clickable className="save-b" onClick={addMachine}>
                        <img src={images.save} className="cancel-icon" />
                        Save
                    </Clickable>
                </div>
            </div>
        </Page>
    );
};

export default AddMachine;
